import { createSlice } from "@reduxjs/toolkit";
import {
  updateDoctorDetails,
} from "../../actions/users/usersData";

const initialState = {
  responseMessage: null,
};

export const createNewDoctorSlice = createSlice({
  name: "createuser",
  initialState,
  reducers: {
    responseMessage: (state) => {
      state.responseMessage = null;
    },
  },
  extraReducers: {
    [updateDoctorDetails.fulfilled]: (state, { payload }) => {
      state.responseMessage = "User Updated successfully";
    },
    [updateDoctorDetails.rejected]: (state, { error }) => {
      state.responseMessage = error.message;
    },
  },
});

export const { responseMessage, createUser } = createNewDoctorSlice.actions;

export default createNewDoctorSlice.reducer;
